import script from "./SelectSubject.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSubject.vue?vue&type=script&setup=true&lang=js"

import "./SelectSubject.vue?vue&type=style&index=0&id=31ada062&lang=css"

const __exports__ = script;

export default __exports__